import { strings } from '@constants'

export const FactoryColumn = () => [
	{
		label: strings('order', 'id'),
		key: 'order_id',
	},
	{
		label: strings('order', 'date'),
		key: 'order_date',
	},
	{
		label: strings('factory', 'id'),
		key: 'factory_id',
	},
	{
		label: strings('partner'),
		key: 'partner',
	},
	{
		label: strings('partner', 'contact'),
		key: 'partner_contact',
	},
	{
		label: strings(['input', 'order', 'items']),
		key: 'input_order_items',
	},
	{
		label: strings(['output', 'order', 'items']),
		key: 'output_order_items',
	},
	{
		label: strings(['outgoing', 'order', 'id']),
		key: 'outgoing_order_id',
	},
	{
		label: strings('status'),
		key: 'status',
	},
]

export const UserColumn = () => [
	{
		label: strings('user', 'id'),
		key: 'user_id',
	},
	{
		label: strings('name'),
		key: 'full_name',
	},
	{
		label: strings('mobile'),
		key: 'mobile_number',
	},
	{
		label: strings('email', 'id'),
		key: 'email_id',
	},
	{
		label: strings('organisation', 'name'),
		key: 'organisation_name',
	},
	{
		label: strings('role'),
		key: 'role',
	},
	{
		label: strings('remarks'),
		key: 'remarks',
	},
	{
		label: strings(['is', 'user', 'active']),
		key: 'is_user_active',
	},
	{
		label: strings('categories'),
		key: 'categories',
	},
]

export const OrdersColumn = () => [
	{
		label: strings('order', 'id'),
		key: 'order_id',
	},
	{
		label: strings('order', 'date'),
		key: 'order_date',
	},
	{
		label: strings('buyer'),
		key: 'buyer',
	},
	{
		label: strings('buyer', 'contact'),
		key: 'buyer_contact',
	},
	{
		label: strings('supplier'),
		key: 'supplier',
	},
	{
		label: strings('products'),
		key: 'products',
	},
	{
		label: strings('ordered_weight_mt'),
		key: 'ordered_weight',
	},
	{
		label: strings('serviced_weight_mt'),
		key: 'serviced_weight',
	},
]

export const LedgersColumn = () => [
	{
		label: strings('date'),
		key: 'transaction_date',
	},
	{
		label: strings('source'),
		key: 'source',
	},
	{
		label: `${strings(['invoice_no', '/', 'transaction', 'number'])}`,
		key: 'transaction_number',
	},
	{
		label: strings('transaction', 'type'),
		key: 'transaction_type',
	},
	{
		label: strings('organisation', 'name'),
		key: 'transaction_remarks',
	},
	{
		label: strings('amount'),
		key: 'transaction_amount',
	},
	{
		label: strings('balance', 'amount'),
		key: 'balance',
	},
	{
		label: strings('due', 'date'),
		key: 'due_date',
	},
	{
		label: strings('status'),
		key: 'status',
	},
	{
		label: strings('order_id'),
		key: 'order_id',
	},
]

export const DuePaymentsColumn = () => [
	{
		label: strings('id'),
		key: 'organisation_id',
	},
	{
		label: strings('organisation'),
		key: 'organisation',
	},
	{
		label: strings('current'),
		key: 'current',
	},
	{
		label: '0-7',
		key: '0-7',
	},
	{
		label: '07-15',
		key: '7-15',
	},
	{
		label: '15-30',
		key: '15-30',
	},
	{
		label: '30-45',
		key: '30-45',
	},
	{
		label: '45+',
		key: '45+',
	},
	{
		label: strings('total'),
		key: 'total',
	},
	{
		label: strings('interest'),
		key: 'interest',
	},
	{
		label: strings('sales', 'person'),
		key: 'sales_person',
	},
	{
		label: strings('region'),
		key: 'region',
	},
	{
		label: strings('platform'),
		key: 'platform',
	},
]

export const PaymentPastRecordColumn = () => [
	{
		label: strings('zoho', 'name'),
		key: 'zoho_name',
	},
	{
		label: strings('pan'),
		key: 'pan',
	},
	{
		label: strings('formatted', 'date'),
		key: 'formattedDate',
	},
	{
		label: strings('past', 'payment_terms'),
		key: 'pastPaymentsTerms',
	},
	{
		label: strings('average_past_delays'),
		key: 'averagePastDelays',
	},
	{
		label: strings('excess_ctc'),
		key: 'excessCTC',
	},
	{
		label: strings('gmv'),
		key: 'gmv',
	},
	{
		label: strings('gm'),
		key: 'gm',
	},
]

export const AdvanceToSupplierColumn = () => [
	{
		label: strings('id'),
		key: 'organisation_id',
	},
	{
		label: strings('organisation'),
		key: 'organisation',
	},

	{
		label: strings('total'),
		key: 'total',
	},

	{
		label: strings('supply', 'person'),
		key: 'supply_person',
	},
	{
		label: strings('region'),
		key: 'region',
	},
	{
		label: strings('platform'),
		key: 'platform',
	},
	{
		label: strings(['last', 'payment', 'Date']),
		key: 'lastPaymentDate',
	},
]

export const ActiveInvoices = () => [
	{
		label: strings('invoice_no'),
		key: 'invoice_number',
	},
	{
		label: strings('original_invoice_number'),
		key: 'original_invoice_number',
	},
	{
		label: strings('invoice', 'date'),
		key: 'invoice_date',
	},
	{
		label: strings('order_id'),
		key: 'order_id',
	},
	{
		label: strings('order_date'),
		key: 'order_date',
	},
	{
		label: strings('buyer'),
		key: 'buyer',
	},
	{
		label: strings('buyer_contact'),
		key: 'buyer_contact',
	},
	{
		label: strings('vehicle', 'number'),
		key: 'vehicle_number',
	},
	{
		label: strings('driver', 'number'),
		key: 'driver_number',
	},
	{
		label: strings('serviced_weight'),
		key: 'serviced_weight',
	},
	{
		label: strings('input', 'type'),
		key: 'input_type',
	},
	{
		label: strings('amount'),
		key: 'amount',
	},
	{
		label: strings('status'),
		key: 'status',
	},
]

export const PastRecordColumn = () => [
	// { key: 'name', label: strings('name'), mobile: true, align: 'left', exportOnly: true },
	{ key: 'organisation_name', label: strings('organisation', 'name'), cellWidth: 15, mobile: true, align: 'left' },
	{ key: 'pan', label: strings('pan'), mobile: false, align: 'left' },
	{ key: 'payment_terms', label: strings(['past', 'payments', 'terms']), cellWidth: 10, mobile: false, align: 'left' },
	{ key: 'delays', label: strings('average_past_delays'), cellWidth: 10, mobile: true, align: 'left' },
	{ key: 'excess_ctc', label: strings('excess_ctc'), mobile: true, align: 'left' },
	{ key: 'gross_margin', label: strings('gmv'), mobile: true, align: 'left' },
	{ key: 'gross_margin_percentage', label: strings('gm'), mobile: true, align: 'left' },
]

export const CollectionsColumn = () => [
	{
		label: strings('client'),
		key: 'client',
	},
	{
		label: strings('amount'),
		key: 'payment_amount',
	},

	{
		label: strings('mode_of_payment'),
		key: 'payment_mode',
	},

	{
		label: strings('expected', 'date'),
		key: 'expected_payment_date',
	},
	{
		label: strings('manager'),
		key: 'manager',
	},
	{
		label: strings('region'),
		key: 'region',
	},
	{
		label: strings('message'),
		key: 'message',
	},
	{
		label: strings('status'),
		key: 'status',
	},
]

export const BillsColumn = () => [
	{
		label: strings('invoice', 'number'),
		key: 'original_invoice_number',
	},
	{
		label: strings('invoice', 'amount'),
		key: 'invoice_amount',
	},
	{
		label: strings('invoice', 'date'),
		key: 'invoice_date',
	},
	{
		label: strings('organisation', 'name'),
		key: 'organisation_name',
	},
]

export const leadColumn = () => [
	{
		label: strings('created', 'at'),
		key: 'created_at',
	},
	{
		label: strings('created', 'by'),
		key: 'created_by',
	},
	{
		label: strings('mobile_number'),
		key: 'mobile_number',
	},
	{
		label: strings('organisation', 'id'),
		key: 'organisation_id',
	},
	{
		label: strings('organisation', 'name'),
		key: 'organisation_name',
	},
	{
		label: strings('source'),
		key: 'source',
	},
	{
		label: strings('status'),
		key: 'status',
	},
	{
		label: strings('sales', 'manager'),
		key: 'sales_manager',
	},
	{
		label: strings('business', 'category'),
		key: 'business_category',
	},
	{
		label: strings('location'),
		key: 'location',
	},
]
export const OrderBooksColumn = () => [
	{
		label: '#SPO',
		key: 'so_number',
	},
	{
		label: 'Supplier',
		key: 'supplier_name',
	},
	{
		label: 'SPO Amount',
		key: 'spo_amount',
	},
	{
		label: 'SPO Weight',
		key: 'spo_quantity',
	},
	{
		label: '#Order',
		key: 'order_id',
	},
	{
		label: 'Order Date',
		key: 'order_date',
	},
	{
		label: '#Enquiry',
		key: 'enquiry_id',
	},
	{
		label: '#PO',
		key: 'po_number',
	},
	{
		label: 'Buyer',
		key: 'customer_name',
	},
	{
		label: 'Region',
		key: 'region',
	},
	{
		label: 'Platform',
		key: 'platform',
	},
	{
		label: 'Terms',
		key: 'payment_terms',
	},
	{
		label: 'Address',
		key: 'shipping_address',
	},
	{
		label: 'Sales Person',
		key: 'sales_person_name',
	},
	{
		label: 'SPOC',
		key: 'supply_spoc_name',
	},
	{
		label: 'Order Weight',
		key: 'ordered_weight',
	},
	{
		label: 'Order Amount',
		key: 'ordered_amount',
	},

	{
		label: 'Serviced Amount',
		key: 'serviced_amount',
	},

	{
		label: 'Serviced Quantity',
		key: 'serviced_weight',
	},

	{
		label: 'Pending Quantity',
		key: 'pending_quantity',
	},
	{
		label: 'POD Tenure',
		key: 'pod_tenure',
	},
	{
		label: 'Advance Tenure',
		key: 'advance_tenure',
	},
	{
		label: 'LC Tenure',
		key: 'lc_tenure',
	},
]

export const monthlyTargetReportColumns = () => [
	{
		label: strings('full_name'),
		key: 'full_name',
	},
	{
		label: strings('region'),
		key: 'region',
	},
	{
		label: strings('manager_name'),
		key: 'manager_name',
	},
	{
		label: strings(['monthly_target']),
		key: 'monthly_target',
	},
	{
		label: strings(['target_achieved']),
		key: 'target_achieved',
	},
	{
		label: strings('percentage'),
		key: 'percentage',
	},
	{
		label: 'Order Book (in MT)',
		key: 'pending_quantity',
	},
	{
		label: 'Order Book (in Rs)',
		key: 'pending_quantity_in_rupees',
	},
]

export const dispatchPlanColumns = () => [
	{ label: strings('enquiry_id'), key: 'enquiry_id' },
	{ label: strings('order_id'), key: 'order_id' },
	{ label: strings('buyer'), key: 'buyer_name' },
	{ label: strings('supplier'), key: 'supplier_name' },
	{ label: strings('logistics_handler'), key: 'logistics_handler' },
	{ label: strings('region'), key: 'region' },
	{ label: strings('plan_for_today'), key: 'today_plan' },
	{ label: strings('plan_from_yesterday'), key: 'yesterday_plan' },
	{ label: strings('serviced_quantity_in_mts'), key: 'serviced_quantity' },
	{ label: strings('quantity_mts'), key: 'total_quantity' },
	{ label: strings('supply', 'person'), key: 'supply_person' },
	{ label: strings('overdue'), key: 'payment_status' },
	{ label: strings('po', 'status'), key: 'po_status' },
	{ label: strings('ageing'), key: 'age' },
]

export const dispatchPlansAllReportColumns = () => [
	{ label: strings('enquiry_id'), key: 'enquiry_id' },
	{ label: strings('order_id'), key: 'order_id' },
	{ label: strings('buyer'), key: 'buyer' },
	{ label: strings('supplier'), key: 'supplier' },
	{ label: strings('logistics_handler'), key: 'logistics_handler' },
	{ label: strings('region'), key: 'region' },
	{ label: strings('dispatch', 'quantity'), key: 'dispatch_quantity' },
	{ label: strings('serviced', 'quantity'), key: 'serviced_quantity' },
	{ label: strings('plan_start_date'), key: 'plan_start_date' },
	{ label: strings('plan_current_date'), key: 'plan_current_date' },
	{ label: strings('expected', 'amount'), key: 'expected_amount' },
	{ label: strings('supply', 'person'), key: 'supply_person' },
	{ label: strings('status'), key: 'status' },
	{ label: strings('ageing'), key: 'age' },
]

export const dispatchPlanReportColumns = () => [
	{
		label: strings('platform'),
		key: 'platform',
	},
	{
		label: strings(['total', 'planned', 'quty']),
		key: 'total_planned_quantity',
	},
	{
		label: strings(['total', 'dispatched', 'quty']),
		key: 'total_dispatched_quantity',
	},

	{
		label: strings(['total', 'pending', 'quty']),
		key: 'total_pending_quantity',
	},
	{
		label: strings(['plan', 'from', 'yesterday']),
		key: 'yesterday_planned_quantity',
		mobile: true,
	},
	{
		label: strings(['dispatched', 'yesterday']),
		key: 'yesterday_dispatched_quantity',
		mobile: true,
	},

	{
		label: strings(['new', 'plan']),
		key: 'today_planned_quantity',
		mobile: true,
	},
	{
		label: strings(['new', 'plan', 'dispatched', 'quty']),
		key: 'today_dispatched_quantity',
		mobile: true,
	},
]

export const detailedReportColumns = () => [
	{
		label: strings('region'),
		key: 'region',
	},
	{
		label: strings('logistics_handler'),
		key: 'logistics_handler',
	},
	{
		label: strings('age'),
		key: 'age',
	},
	{
		label: strings('plan', 'quantity'),
		key: 'plan_quantity',
	},
	{
		label: strings('supplier', 'name'),
		key: 'supplier_name',
	},
	{
		label: strings('buyer', 'name'),
		key: 'buyer_name',
	},
	{
		label: strings('pending', 'quantity'),
		key: 'pending_quantity',
	},
	{
		label: strings('dispatched', 'quantity'),
		key: 'dispatched_quantity',
	},
]

export const tenderbookUserListColumns = () => [
	{
		label: strings('mobile', 'number'),
		key: 'mobile_no',
	},
	{ label: strings('organisation', 'name'), key: 'company_name' },
	{ label: strings('created', 'at'), key: 'created_date' },
	{
		label: strings('name'),
		key: 'name',
	},
	{ label: strings('gst'), key: 'gst' },
	{ label: strings('categories'), key: 'categories_flat' },
	{ label: strings('subscription_status'), key: 'subscription_status' },
]

export const tenderbookLeadsColumns = () => [
	{ label: strings('company_name'), key: 'company_name' },
	{ label: strings('name'), key: 'name' },
	{ label: strings('mobile', 'number'), key: 'mobile_no' },
	{ label: strings('email_id'), key: 'email_id' },
	{ label: strings('keywords'), key: 'keywords_flat' },
]

export const adminsColumns = () => [
	{ label: strings('created', 'at'), key: 'created_at' },
	{ label: strings('user', 'id'), key: 'user_id' },
	{ label: strings('full_name'), key: 'full_name' },
	{ label: strings('manager', 'name'), key: 'manager_name' },
	{ label: strings('role'), key: 'role' },
	{ label: strings('sub_role'), key: 'sub_role' },
	{ label: strings('region'), key: 'region' },
	{ label: strings('monthly', 'target'), key: 'monthly_target' },
]
